// The artist's mark for a roster row. The fetch it wraps is `useArtistPhotoUrl` (artistPhoto.ts) — see
// there for why the org-lens arrangement is the part worth sharing.
//
// The rail's `RailArtistMark` (RosterShell) is the other caller of that hook and keeps its own 34px chrome
// box: that mark sits in the shell rather than in a content row, and is sized to the rail.
import { Avatar, type AvatarSize } from "@cntrl/ui";
import { orgInitials } from "../../app/hooks/useOrg.js";
import { useArtistPhotoUrl } from "./artistPhoto.js";

/**
 * An artist's photo, or their initials until there is one.
 *
 * A band is a ROUNDED SQUARE, never a circle — the person/band shape split `PersonAvatar` owns on the
 * person side. Restating the box, fill and initials in a local class is how that split gets forked.
 */
export function ArtistMark({
  name,
  bandId,
  avatarMediaId,
  size = "md",
}: {
  name: string | null | undefined;
  bandId: string | null | undefined;
  avatarMediaId: string | null | undefined;
  size?: AvatarSize;
}) {
  const url = useArtistPhotoUrl(bandId, avatarMediaId);
  return <Avatar src={url} initials={orgInitials(name)} size={size} shape="rounded" />;
}
